import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie, X } from "lucide-react";

const STORAGE_KEY = "dra_cookie_consent";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (!saved) {
      // Slight delay so it doesn't hit immediately on load
      const t = setTimeout(() => setVisible(true), 800);
      return () => clearTimeout(t);
    }
  }, []);

  const setConsent = (value) => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ value, ts: new Date().toISOString() }));
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-banner"
      className="fixed bottom-0 left-0 right-0 z-[100] p-4 md:p-6 animate-fade-up"
    >
      <div className="max-w-5xl mx-auto bg-slate-900 text-white border border-slate-800 shadow-2xl">
        <div className="p-6 md:p-8 flex flex-col md:flex-row gap-6 items-start md:items-center">
          <div className="flex items-start gap-4 flex-1">
            <div className="w-10 h-10 border border-white/30 flex items-center justify-center flex-shrink-0">
              <Cookie size={18} strokeWidth={1.5} />
            </div>
            <div>
              <h3 className="font-heading font-semibold text-base md:text-lg mb-1">Wir respektieren Ihre Privatsphäre</h3>
              <p className="text-sm text-slate-300 leading-relaxed">
                Diese Website verwendet ausschließlich technisch notwendige Cookies, um die Funktion
                sicherzustellen (z. B. Admin-Login). Es findet kein Tracking und keine Weitergabe an
                Dritte statt. Details in der{" "}
                <Link to="/datenschutz" className="underline hover:text-red-400">Datenschutzerklärung</Link>.
              </p>
            </div>
          </div>
          <div className="flex gap-3 flex-shrink-0 w-full md:w-auto">
            <button
              onClick={() => setConsent("declined")}
              data-testid="cookie-decline"
              className="flex-1 md:flex-none border border-white/30 px-5 py-2.5 text-sm hover:bg-white hover:text-slate-900 transition-crisp"
            >
              Ablehnen
            </button>
            <button
              onClick={() => setConsent("accepted")}
              data-testid="cookie-accept"
              className="flex-1 md:flex-none bg-white text-slate-900 px-5 py-2.5 text-sm font-medium hover:bg-red-500 hover:text-white transition-crisp"
            >
              Akzeptieren
            </button>
          </div>
          <button
            onClick={() => setConsent("dismissed")}
            data-testid="cookie-close"
            aria-label="Schließen"
            className="absolute top-3 right-3 text-slate-400 hover:text-white"
          >
            <X size={18} />
          </button>
        </div>
      </div>
    </div>
  );
}
